import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-input',
  templateUrl: './add-input.component.html',
  styleUrl: './add-input.component.scss'
})
export class AddInputComponent {
  @Input() placeholder: string = 'Enter option'; // Placeholder mặc định
  @Input() initialValues: { key: string; value: string }[] = []; // Giá trị ban đầu
  @Output() valuesChange = new EventEmitter<{ key: string; value: string }[]>(); // Sự kiện gửi giá trị ra ngoài

  inputs: { key: string; value: string }[] = [];
  private nextId = 1; // ID tiếp theo cho input

  constructor() {
    this.inputs = [...this.initialValues];
    if (this.inputs.length > 0) {
      this.nextId = Math.max(...this.inputs.map(input => parseInt(input.key.toString(), 10))) + 1;
    }
  }

  addInput(): void {
    // Increment the nextId first and then push the new input object
    this.inputs.push({ key: this.nextId.toString(), value: '' });
    this.nextId++; // Increment the nextId after using it
    this.emitValues();
  }
  

  removeInput(index: number): void {
    this.inputs.splice(index, 1);
    this.emitValues();
  }

  updateInput(index: number, value: string): void {
    this.inputs[index].value = value;
    this.emitValues();
  }

  trackByFn(index: number, item: { key: string; value: string }): string {
    return item.key; // Trả về ID để Angular không tái tạo DOM
  }

  private emitValues(): void {
    this.valuesChange.emit(this.inputs);
  }
}

